import React, { useEffect, useState } from 'react';
import { Bar, Doughnut, Line } from "react-chartjs-2";

import { Chart, CategoryScale, LinearScale, BarElement, PointElement, Tooltip, Legend, } from "chart.js";

const TotalTenantSalesChart = ({ sales }) => {

 const [sales_data, setSalesData] = useState(sales);

 Chart.register(CategoryScale, LinearScale, BarElement, PointElement, Tooltip, Legend,);

 useEffect(() => {
  setSalesData(sales);
 }, [sales]);// invert sales

 const invertedSales = sales_data?.slice().reverse();

 const data = {
  labels: invertedSales?.map((sale) => { return sale?.date; }),
  dataUnit: "Orders",
  lineTension: 0.3,
  datasets: [
   {
    label: "Orders",
    data: invertedSales?.map((sale) => { return sale?.count; }),
    borderColor: "#2596be",
    backgroundColor: "rgba(0, 153, 255, 0.1)",
    fill: true,
    tension: 0.4
   },
  ],
 };

 return (
  <>
   <Line
    data={data}
    options={{
     plugins: {
      legend: { display: true },
      tooltip: {
       enabled: true,
       callbacks: {
        label: function (context) {
         return context.parsed.y;
        },
       },
      },
     },
     maintainAspectRatio: false,
     scales: {
      y: {
       beginAtZero: true,
       ticks: { color: "#9eaecf", font: { size: 11 }, padding: 10 },
       grid: { color: "rgba(82, 100, 132, 0.2)" }
      },
      x: {
       ticks: { color: "#9eaecf", font: { size: 9 }, padding: 10 },
       grid: { color: "transparent" }
      },
     },
    }}
   />
  </>
 );
};

export default TotalTenantSalesChart;